// extracted by mini-css-extract-plugin
module.exports = {"Weather":"weather_Weather__wXf7Z","Icon":"weather_Icon__DEOVE","IconForecast":"weather_IconForecast__7RbbE","Forecast":"weather_Forecast__QRuKN"};